import get from "lodash/get";
import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
import ResourceAppResource, {TYPE as RESOURCE_TYPE} from "@milestoneslabs/milestones-core-js/src/AppResources/ResourceAppResource";
import isEmpty from "lodash/isEmpty";
import has from "lodash/has";
import first from "lodash/first";
import OrganizationMemberAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/OrganizationMemberAppResource";
import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
import ServiceProviderAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";
import PlaybookAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PlaybookAppResource";


export default {
    data() {
        return {
            serviceProviderTypes: new AppResourceCollection('service-provider-type'),
            organization: new OrganizationMemberAppResource({}),
            playbooks: new AppResourceCollection('playbook'),
            serviceProvidersList: null,
            mortgageResource: new ResourceAppResource({}),
            hasServiceProviders: true,
        };
    },

    computed: {
        organizationDisabledResources() {
            return get(this.organization, 'resources.disabledResources', []);
        },

        hasServiceProvidersList() {
            return !isEmpty(this.serviceProvidersList);
        },

        isMortgageAvailable() {
            return !isEmpty(this.mortgageResource) && this.mortgageResource.exists;
        },
    },

    methods: {
        async fetchServiceProviderTypes() {
            try {
                const search = new AppResourceSearch('service-provider-type');
                await search.setSearchData({pagination: 'disabled'}, false);
                await search.search();

                this.serviceProviderTypes = search.appResourceCollection;
            } catch (e) {
                console.error(e);
            }
        },

        async fetchMortgageResource() {
            const enabledResources = this.getEnabledResources();
            const enabledResourceUuids = enabledResources.map(resource => resource.resourceUuid);

            if (!isEmpty(enabledResourceUuids)) {
                const mortgageType = this.getServiceProviderType('mortgage');
                if (mortgageType === undefined) {
                    return;
                }
                try {
                    const search = new AppResourceSearch('resource');

                    await search.setSearchData({
                        pageSize: 1,
                        include: [
                            'serviceProviderType'
                        ],
                        filter: new ApiFilter({
                            params: {
                                uuid: {
                                    value: enabledResourceUuids,
                                    operator: 'in',
                                },
                                type: RESOURCE_TYPE.REFERRAL_PARTNER,
                                serviceProviderTypeUuid: mortgageType.uuid,
                                isActive: true,
                            }
                        }),
                    }, false);

                    await search.search();

                    if (search.appResourceCollection.isNotEmpty) {
                        this.mortgageResource = search.appResourceCollection.getFirst();
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },

        async fetchServiceProviders() {
            try {
                const serviceProvider = new ServiceProviderAppResource({});
                const response = await serviceProvider.searchLandingPageServiceProviders({
                    serviceProviderListUuid: this.serviceProvidersList,
                    serviceProviderTypeUuid: this.mortgageResource.serviceProviderTypeUuid,
                    landingPageUuid: this.landingPage.uuid,
                });

                if (isEmpty(response.appResourceCollection)) {
                    this.hasServiceProviders = false;
                    return;
                }

                if (
                    !response.appResourceCollection instanceof AppResourceCollection ||
                    response.appResourceCollection.isEmpty
                ) {
                    this.hasServiceProviders = false;
                    return;
                }

                this.hasServiceProviders = true;
            } catch (e) {
                console.error(e);
                this.showNotification({
                    type: 'error',
                    message: 'Something went wrong. Please, try again later.',
                });
            }
        },

        setAvailablePlaybooks() {
            if (
                has(this.landingPage, 'buy.playbook') &&
                !isEmpty(this.landingPage.buy.playbook) &&
                this.landingPage.buy.playbook instanceof PlaybookAppResource &&
                this.landingPage.buy.playbook.exists
            ) {
                this.playbooks.push(this.landingPage.buy.playbook);
            }

            if (
                has(this.landingPage, 'sell.playbook') &&
                !isEmpty(this.landingPage.sell.playbook) &&
                this.landingPage.sell.playbook instanceof PlaybookAppResource &&
                this.landingPage.sell.playbook.exists
            ) {
                this.playbooks.push(this.landingPage.sell.playbook);
            }
        },

        setAvailableServiceProviderList() {
            this.playbooks.each(playbook => {
                const serviceProviderListUuid = get(
                    playbook,
                    'settings.generalSettings.serviceProviders.serviceProvidersListUuid',
                );

                if (
                    !isEmpty(serviceProviderListUuid) &&
                    isEmpty(this.serviceProvidersList)
                ) {
                    this.serviceProvidersList = serviceProviderListUuid;
                }
            });
        },

        getServiceProviderType(title) {
            return first(this.serviceProviderTypes.toArray().filter(
                type => type.title.toLowerCase().trim() === title.toLowerCase().trim()
            ));
        },

        getEnabledResources() {
            let resources = [];

            this.playbooks.each(playbook => {
                const resourceSettings = get(playbook, `settings.resources`, {});

                let uuidRegExp = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;
                const stageUuids = Object.keys(resourceSettings).filter(key => key.match(uuidRegExp));

                stageUuids.forEach((stageUuid) => {
                    resources.push(...resourceSettings[stageUuid]);
                });

                // filter resources disabled at playbook level
                resources = resources.filter(resource => resource.isActive);
                // filter resources disabled at organization level
                resources = resources.filter(resource => !this.organizationDisabledResources.includes(resource.resourceUuid));
            });

            return resources;
        },
    },

    async mounted() {
        // temporary disable service provider fetch
        // await this.fetchServiceProviderTypes();
    }
};
